var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-alert',{attrs:{"show":"","variant":"primary","align":"center"}},[_vm._v(_vm._s(_vm.$t('copywrite')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }